import { ComponentModel } from '@/helpers/entities/models/ComponentModel';
import { EcommerceCartSettingModel } from './EcommerceCartSettingModel';
export class EcommerceAppModel {
    constructor(app) {
        this.b2cProductKey = 'ecommerce-b2c-product-inventory';
        this.inquiryProductKey = 'inquiry-product-inventory';
        this.b2bProductKey = 'b2b-product-inventory';
        this.storeManagemenProductKey = 'mall-stores-management-product-inventory';
        this.shopifyProductKey = 'shopify-product-inventory';
        this.name = app.name;
        this.uuid = app.uuid;
        this.ordersExportable = app.ordersExportable;
        this.appliesKyc = app.appliesKyc;
        this.kioskTracker = app.kioskTracker;
        this.allowProductRemarks = app.allowProductRemarks;
        this.rebatable = app.rebatable;
        this.bulkable = app.bulkable;
        this.importableCsv = app.importableCsv;
        this.productTrackable = app.productTrackable;
        this.plan = app.plan;
        this.newProTierType = app.newProTierType;
        this.allowAdvanceOrder = app.allowAdvanceOrder;
        this.referrable = app.referrable;
        this.withShippingParkAndMunch = app.withShippingParkAndMunch;
        this.withLalamoveShipping = app.withLalamoveShipping;
        this.insurance = app.insurance;
        this.distributorId = app.distributorId;
        this.assignedLocationIds = app.assignedLocationIds;
        this.sunLife = app.sunLife;
        this.emailNotificationRecipientsList = app.emailNotificationRecipientsList;
        const component = (componentNode) => {
            return new ComponentModel(componentNode.node);
        };
        this.components = app.components.edges.map(component);
        if (app.ecommerceAppSetting) {
            this.setting = new EcommerceCartSettingModel(app.ecommerceAppSetting);
        }
    }
    get productComponent() {
        const product = (comp) => {
            return (comp.key === this.b2cProductKey ||
                comp.key === this.inquiryProductKey ||
                comp.key === this.b2bProductKey ||
                comp.key === this.storeManagemenProductKey ||
                comp.key === this.shopifyProductKey);
        };
        return this.components.find(product) || null;
    }
}
